module.exports = __webpack_public_path__ + "static/media/bg-cover-3.ebce923d.png";